import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';
import styles from '../../styles/components/HelpLink.module.css';

/**
 * HelpLink - Kontextuelles Hilfe-Icon das auf einen Hilfe-Abschnitt verlinkt
 *
 * @param {string} anchor - Anker-ID ohne # (z.B. "produkt-erstellen")
 * @param {string} label - Tooltip-Text (optional)
 */
function HelpLink({ anchor, label }) {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('helpLink.defaultLabel');

  return (
    <Link
      to={`/hilfe#${anchor}`}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.helpLink}
      title={resolvedLabel}
      aria-label={resolvedLabel}
    >
      <Icon name="helpCircle" size="sm" />
    </Link>
  );
}

export default HelpLink;
